import React, { useEffect, useState } from 'react'
import { Client } from '../../../../_models/Client.model';
import { getAllClients } from '../../../../_utils/resourceAPI';
import { UpdateClient } from '../UpdateClients/UpdateClient';
import { useUserContext } from '../../../../_context/UserContext';
import { useClientContext } from '../../../../_context/ClientContext';
import { ClientUpdatedSuccessModal } from '../UpdateClients/ClientUpdatedSuccessModal';
import EmptyClient from '../../../../_resources/JsonData/EmptyClient.json';
import { ClientDeleteSuccessModal } from '../UpdateClients/ClientDeletedSuccessModal';
import { ClientSearchAndFilter } from '../../../../htmlComponents/clientSearchAndFilter';
import '../../../Admin/AddUsers/AddUsers.css';

const LoadingSpinner = () => (
  <div className="au-empty">
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#2563C0" strokeWidth="2.5" strokeLinecap="round" style={{ animation: "spin 0.9s linear infinite" }}>
      <path d="M21 12a9 9 0 1 1-6.219-8.56" />
    </svg>
    <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
  </div>
);

export const AddedClients = () => {
  const [filteredClients, setFilteredClients] = useState<Client[]>([]);
  const [noDataOrLoadingData, setNoDataOrLoadingData] = useState<string>("");
  const { setCurrentPage } = useUserContext();
  const { setClientUpdated, setClient, setAllClients, setClientDeleted } = useClientContext();

  const fetchClients = () => {
    getAllClients()
      .then(res => setAllClients(res.data as Client[]))
      .catch(() => console.log("Failed to fetch clients"));
  };

  useEffect(() => {
    setClient(EmptyClient);
    setCurrentPage("View Clients");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onClientUpdated = () => { fetchClients(); setClientUpdated(true); };
  const onClientDeleted = () => { fetchClients(); setClientDeleted(true); };

  return (
    <div>
      {/* Search / filter — existing component */}
      <ClientSearchAndFilter
        setFiltererdClients={setFilteredClients}
        setDataStatus={setNoDataOrLoadingData}
      />

      {filteredClients.length > 0 ? (
        <div className="au-table-wrap" style={{ marginTop: 16 }}>
          <table className="au-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Address</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredClients.map(client => client ? (
                <tr key={client.Id}>
                  <td data-label="Name"><span className="truncate-text">{client.Name}</span></td>
                  <td data-label="Email" style={{ color: "#6B7280" }}><span className="truncate-text">{client.Email}</span></td>
                  <td data-label="Address" style={{ color: "#6B7280", fontSize: "0.8rem" }}>
                    <span className="truncate-text">{`${client.Address.Line1} ${client.Address.Line2 ?? ""} ${client.Address.Suburb} ${client.Address.Postcode}`.trim()}</span>
                  </td>
                  <td data-label="Action">
                    <UpdateClient
                      clientToUpdate={client}
                      onClientUpdated={onClientUpdated}
                      onClientDeleted={onClientDeleted}
                    />
                  </td>
                </tr>
              ) : null)}
            </tbody>
          </table>
        </div>
      ) : (
        noDataOrLoadingData === "Loading Clients"
          ? <LoadingSpinner />
          : <div className="au-empty">{noDataOrLoadingData}</div>
      )}

      <ClientUpdatedSuccessModal />
      <ClientDeleteSuccessModal />
    </div>
  );
};
